<template lang="html">
  <chart :chartData="currentDataChart" :options="options" v-if="currentDataChart !== undefined"></chart>
  <spinner v-else></spinner>
</template>

<script>
import * as R from 'ramda'
import moment from 'moment'
import Chart from '@/pages/statistics/components/graphiques/BarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import {statusLabel} from '@/helpers/labels'

export default {
  props: ['showAmountNotNumber', 'chartData', 'dates'],
  data () {
    return {
      backgroundColors: {
        1: '#3f48cc',
        5: '#00a8f3',
        6: '#f30000',
        9: '#ffca18',
        10: '#36A974',
        11: '#b83dba',
        12: '#585858',
        13: '#a20020',
        14: '#ab0022',
        15: '#be5763',
        20: '#31953e'
      },
      options: undefined
    }
  },
  components: {
    'chart': Chart,
    'spinner': Spinner
  },
  created () {
    let that = this
    this.options = {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        xAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: false
          }
        }],
        yAxes: [{
          ticks: {
            min: 0,
            stepSize: 200,
            beginAtZero: true
          },
          stacked: true
        }]
      },
      tooltips: {
        mode: 'index',
        callbacks: {
          label (tooltipItem, data) {
            if (tooltipItem.value === '0') {
              return undefined
            }
            return data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.value
          }
        }
      },
      legend: {
        display: true,
        fullWidth: false,
        align: 'center'
      }
    }
  },
  computed: {
    currentDataChart () {
      if (this.chartData !== undefined) {
        return this.makeChartData(this.chartData)
      }
      return undefined
    }
  },
  watch: {
    showAmountNotNumber: {
      handler () {
        if (this.$engine.monitoring.graphByStatus !== undefined) {
          this.chartData = this.makeChartData(this.$engine.monitoring.graphByStatus)
        }
      }
    }
  },
  methods: {
    makeChartData (rawData) {
      let data = {
        labels: [],
        datasets: [],
        totalValue: []
      }

      const startDate = new Date(this.dates.begin)
      const date = new Date(startDate.getTime())
      const endDate = new Date(this.dates.end)

      console.log('rawData.creditor', rawData.creditor)

      // set chartData.labels
      while (date <= endDate) {
        let dateLabel = date.toISOString().split('T')[0]
        data.labels.push(dateLabel)
        date.setDate(date.getDate() + 1)
      }

      // set chartData.datasets
      let statusList = Object.keys(this.backgroundColors)
      let datasets = []
      // init datasets
      let that = this
      statusList.forEach(status => {
        let label = that.$i18n.t('common.status.rtp.' + status)
        let backgroundColor = that.backgroundColors[status]
        let datas = []
        for (let i = 0; i < data.labels.length; i++) {
          let date = data.labels[i]
          let nbRTP = 0
          if (rawData.creditor && rawData.creditor[date] && rawData.creditor[date][status] && rawData.creditor[date][status].number) {
            nbRTP = rawData.creditor[date][status].number
          }
          datas.push(nbRTP)
        }
        datasets.push({
          label: label,
          backgroundColor: backgroundColor,
          data: datas
        })
      })

      data.datasets = datasets
      console.log('made chartdata', data)
      return data
    }
  }
}
</script>
